import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=36355324&"
import script from "./DocumentsTab.vue?vue&type=script&lang=js&"
export * from "./DocumentsTab.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTab.vue?vue&type=style&index=0&id=36355324&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports